import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Modal } from "antd";
import { Alert, Icon } from "@devowl-wp/react-folder-tree";
import { __ } from "../../utils/i18n.js";
import { getProFeature } from "../../utils/proFeatures.js";
import { request } from "../../utils/request.js";
import { getRmlModalStackProps } from "../../utils/rmlModalStack.js";
import { rmlOpts } from "../../utils/rmlOpts.js";
function ProBox({ feature, onClose }) {
    const redirect = ()=>{
        window.open(`${rmlOpts.others.proUrl}&feature=${feature}`, "_blank")?.focus();
        onClose();
    };
    let title;
    let modalContent;
    if (feature) {
        const set = getProFeature(feature);
        if (!set) {
            return null;
        }
        title = /*#__PURE__*/ _jsxs("span", {
            children: [
                /*#__PURE__*/ _jsx(Icon, {
                    type: "lock"
                }),
                " ",
                set.title,
                " ",
                __("Get PRO!")
            ]
        });
        modalContent = /*#__PURE__*/ _jsxs("div", {
            children: [
                !!set.image && /*#__PURE__*/ _jsx("img", {
                    src: `https://assets.devowl.io/in-app/wp-real-media-library/${set.image}`
                }),
                /*#__PURE__*/ _jsx("p", {
                    children: set.description
                })
            ]
        });
    }
    return /*#__PURE__*/ _jsx(Modal, {
        open: !!modalContent,
        title: title,
        onOk: redirect,
        onCancel: onClose,
        cancelText: __("No, not interested..."),
        okText: __("I want to learn more!"),
        className: "rml-probox",
        ...getRmlModalStackProps(),
        children: modalContent
    });
}
async function dismiss() {
    await request({
        location: {
            path: "/notice/lite",
            method: "DELETE"
        }
    });
    window.location.reload();
}
const ProFooter = ({ dismissible = false, feature })=>/*#__PURE__*/ _jsx(Alert, {
        message: /*#__PURE__*/ _jsxs("span", {
            children: [
                __("Thanks for using the free version of Real Media Library."),
                " \xb7",
                " ",
                /*#__PURE__*/ _jsx("a", {
                    href: `${rmlOpts.others.proUrl}&feature=${feature}`,
                    target: "_blank",
                    rel: "noreferrer",
                    children: __("Learn more about PRO")
                }),
                dismissible && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        " ",
                        "\xb7",
                        " ",
                        /*#__PURE__*/ _jsx("a", {
                            onClick: dismiss,
                            href: "#",
                            children: __("Hide for 30 days")
                        })
                    ]
                })
            ]
        }),
        type: "info",
        style: {
            marginBottom: "10px"
        }
    });
export { ProFooter, ProBox };
